import {createLogger} from '../../common/logging.config';
const logger = createLogger('publishing-service');

module.exports = ['$http', '$q', '$filter', 'homepageUtil', 'shellUtil', 'userProfileService', function($http, $q, $filter, homepageUtil, shellUtil, userProfileService) {

	//const publishingQuery = '?q=*:*&defType=edismax&indent=on&qf=*&wt=json&fq=classification:(project)&sort=lastModified%20desc&rows=32&start=0&fl=id,name,classification,created,creator,lastModified,lastModifier,document:%5Bjson%5D';
	const options = { year: 'numeric', month: 'short', day: 'numeric' };
	const timeOptions = { hour: 'numeric', minute: 'numeric' };
	
	/**
	* Returns a promise to the JSON for the currently pending publishing jobs
	* @return {Promise}
	*/
	function getCurrentPending() {
		let entriesPending = [];
		
		return new Promise((resolve, reject) => {
			// assume that the pub error service was called first and fetched the latest data
			shellUtil.getProjects(false).then(
				(res) => {
					return res;
				},
				(error) => {
					logger.error('Error retrieving current search publishing data from server: ' + JSON.stringify(error));
					reject (error);
				}
			).then(data => {
				if (typeof data === 'undefined') {
					// looks like we hit an error
					logger.error('Error retrieving current project data from server: data was undefined');
					reject(new Error('No data from search for projects'));
				}
				if (data && data.numFound > 0) {
					for (let doc of data.documents) {
						let document = doc.document;
						if (document.status === "pending" || document.status === "in-progress") {
							logger.info(" got document pending date: " + document.targetDate);
							// if the content gets deleted after a publishing job is set, there is no target date
							if (document.targetDate) {
								let targetDate = new Date(document.targetDate);
								let timeString = targetDate.toLocaleTimeString(homepageUtil.getCurrentLocale().replace('_', '-'), timeOptions);
								// store with each body entry the detailed time for sorting
								//let bodyDateString = "" + targetDate.getTime();
								// now normalize all target dates to same
								//targetDate.setHours(0,0,0,0);
								let dateString = "" + targetDate.getTime();
								let titleString = targetDate.toLocaleDateString(homepageUtil.getCurrentLocale().replace('_', '-'), options);
								let displayName = document.creator || document.creatorId; 
								let bodyEntry = {bodyTitle: document.name, bodyEntryName: displayName, bodyEntryCreatorId: document.creatorId, bodyEntryCount: document.itemCount, time:dateString, bodyId: document.id, bodyKind: document.kind};
								let match = entriesPending.find( element => { return element.date === dateString} );
								if (!match) {
									let bodyArray = [];
									bodyArray.push(bodyEntry);
									entriesPending.push({date:dateString, title:titleString, time:timeString, body:bodyArray});
								}
								else {
									let bodyArray = match.body;
									bodyArray.push(bodyEntry);
								}
							}
						}
					}
				}
				
				// lookup the id of the current user
				userProfileService.getCurrentUserData().then((data) => {
					return data.id;
				}).then(userId => {
					homepageUtil.getPublishingAtAGlancePreferences().then((userPrefs) => {
						let filteredContent = $filter('publishingPreferencesFilter')(entriesPending, userPrefs, userId);
						resolve (filteredContent);
					});
				});
			});
		});		
	}
	
	/**
	* Returns a promise to the JSON for the currently on hold publishing jobs
	* @return {Promise}
	*/
	function getCurrentOnHold() {
		let entriesOnHold = [];
		
		return new Promise((resolve, reject) => {
			// assume that the pub error service was called first and fetched the latest data
			shellUtil.getProjects(false).then(
				(res) => {
					return res;
				},
				(error) => {
					logger.error('Error retrieving current search publishing data from server: ' + JSON.stringify(error));
					reject (error);
				}
			).then(data => {
				if (typeof data === 'undefined') {
					// looks like we hit an error
					logger.error('Error retrieving current project data from server: data was undefined');
					reject(new Error('No data from search for projects'));
				}
				if (data && data.numFound > 0) {
					for (let doc of data.documents) {
						let document = doc.document;
						// check for on hold pending item
						if (document.status === "in-progress" && typeof document.targetDate === 'undefined' &&
							document.kind.includes('publishing-job')
						){
							logger.info(" fetched on-hold document name: " + document.name);
							const titleString = 'Open the publishing job to schedule it.';
							let displayName = document.creator || document.creatorId; 
							let bodyEntry = {bodyTitle: document.name, bodyEntryName: displayName, bodyEntryCreatorId: document.creatorId, /*bodyEntryCount: document.itemCount, time:bodyDateString,*/ bodyId: document.id, bodyKind: document.kind};
							let match = entriesOnHold.find( element => { return element.title === titleString} );
							if (!match) {
								let bodyArray = [];
								bodyArray.push(bodyEntry);
								entriesOnHold.push({ title:titleString, body:bodyArray});
							}
							else {
								let bodyArray = match.body;
								bodyArray.push(bodyEntry);
							}
						}
					}
				}
				
				// lookup the id of the current user
				userProfileService.getCurrentUserData().then((data) => {
					return data.id;
				}).then(userId => {
					homepageUtil.getPublishingAtAGlancePreferences().then((userPrefs) => {
						let filteredContent = $filter('publishingPreferencesFilter')(entriesOnHold, userPrefs, userId);
						resolve (filteredContent);
					});
				});
			});
		});
	}
	
	/**
	* Returns a promise to the JSON for the successfully completed publishing jobs
	* @return {Promise}
	*/
	function getCurrentPublished() {
		
		let entriesPublished = [];
		
		return new Promise((resolve, reject) => {
			shellUtil.getProjects(false).then(
			//authSearchService.getSearchResults(publishingQuery).then(
				(res) => {
					return res;
				},
				(error) => {
					logger.error('Error retrieving current search publishing data from server: ' + JSON.stringify(error));
					reject (error);
				}
			).then(data => {
				if (typeof data === 'undefined') {
					// looks like we hit an error
					logger.error('Error retrieving current project data from server: data was undefined');
					reject(new Error('No data from search for projects'));
				}
				if (data && data.numFound > 0) {
					for (let doc of data.documents) {
						let document = doc.document;
						if (document.status === "complete" || document.status === "published") {
							const completed = document.completed || document.published || document.created;
							logger.info(" got document completed date: " + completed);
							let completedDate = new Date(completed);
							let timeString = completedDate.toLocaleTimeString(homepageUtil.getCurrentLocale().replace('_', '-'), timeOptions);
							// store with each body entry the detailed time for sorting
							//let bodyDateString = "" + completedDate.getTime();
							// now normalize all completed dates to same
							//completedDate.setHours(0,0,0,0);
							let dateString = "" + completedDate.getTime();
							let titleString = completedDate.toLocaleDateString(homepageUtil.getCurrentLocale().replace('_', '-'), options);
							let displayName = document.creator || document.creatorId; 
							let bodyEntry = { bodyTitle: document.name, bodyEntryName: displayName, bodyEntryCreatorId: document.creatorId, bodyEntryCount: document.itemCount, time: dateString, bodyId: document.id, bodyKind: document.kind};
							let match = entriesPublished.find(element => { return element.date === dateString} );
							if (!match) {
								let bodyArray = [];
								bodyArray.push(bodyEntry);
								entriesPublished.push({date:dateString, title:titleString, time:timeString, body:bodyArray});
							}
							else {
								let bodyArray = match.body;
								bodyArray.push(bodyEntry);
							}
						}
					}
				}
				
				// lookup the id of the current user
				userProfileService.getCurrentUserData().then((data) => {
					return data.id;
				}).then(userId => {
					homepageUtil.getPublishingAtAGlancePreferences().then((userPrefs) => {
						let filteredContent = $filter('publishingPreferencesFilter')(entriesPublished, userPrefs, userId);
						resolve (filteredContent);
					});
				});
			});
		});
	}

	// return public API for the REST factory
    return {
    	getCurrentPending: getCurrentPending,
    	getCurrentOnHold: getCurrentOnHold,
    	getCurrentPublished: getCurrentPublished
    };
}];



// WEBPACK FOOTER //
// ./app/common/services/publishing-service.factory.js